<div class="product">
	<div class="image placeholder" />

	<div class="content">
		<div class="text">
			<div class="placeholder" style="width: 100%; height: 16px; margin-bottom: 8px;" />
			<div class="placeholder" style="width: 35%; height: 16px; margin-inline-end: 16px;" />
		</div>
	</div>
</div>

<style lang="scss">
	.placeholder {
		animation: 1s placeholder 0s infinite;
		background: color(primary);
	}

	@keyframes placeholder {
		0% {
			opacity: 1;
		}

		50% {
			opacity: 0.5;
		}

		100% {
			opacity: 1;
		}
	}

	.product {
		position: relative;
		min-height: 430px;

		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.image {
			position: relative;
			width: 100%;
			padding-bottom: 100%;
		}

		.variant-select {
			position: absolute;
			display: inline-block;
			top: 16px;
			inset-inline-start: 16px;
			z-index: 2;
			max-width: 60%;
		}

		.product-image {
			width: 100%;
			aspect-ratio: 1 / 1;
			border-radius: 8px;
		}

		.product-name {
			width: 100%;
		}

		.content {
			display: flex;
			align-items: flex-end;
			padding: 12px 4px 8px 4px;

			.text {
				width: 100%;
			}

			.price {
				color: v(color-black);
			}

			.vat {
				margin-inline-start: 32px;
				opacity: 0.5;
				@include font('text-small');
			}

			.country {
				display: flex;
				flex-direction: column;
				@include font('text-small');
				margin-inline-start: 32px;

				@include media(phone) {
					display: none;
				}

				img {
					margin-bottom: 4px;
				}
			}
		}

		.add-button {
			position: absolute;
			top: 16px;
			inset-inline-end: 16px;
		}
	}
</style>
